<template>
  <div class="page-wrap">
    <PageHeader title="계정 발급" />

    <!-- 학교 등록 + 발급 — 나란히 배치. 전달은 연락처 목록이 아래로 늘어나는
         구조라 별도 줄에 둔다. -->
    <div class="side-by-side">
    <!-- 학교 등록 — 학교 관리(allschool.vue)에서 이동. 계정 발급 전 신규 학교를
         등록하고, 담당 선생님 연락처와 분류(유료/무료/연수/서포터즈/AI/박람회)까지
         한 번에 입력한다. -->
    <FormCard header="학교 등록">
      <div class="register-grid">
        <div class="field-group">
          <label class="field-label">
            교육청 <span class="field-required">(필수)</span>
          </label>
          <v-select
            v-model="regOffice"
            :items="offices"
            variant="outlined"
            density="compact"
            placeholder="교육청을 선택해주세요"
            hide-details="auto"
          />
        </div>

        <div class="field-group">
          <label class="field-label">지역명 (선택)</label>
          <v-text-field
            v-model="regLocation"
            variant="outlined"
            density="compact"
            placeholder="학교이름 앞 지역명"
            hide-details="auto"
          />
        </div>

        <div class="field-group">
          <label class="field-label">
            학교이름 <span class="field-hint-inline">('초등학교' 제외)</span>
            <span class="field-required">(필수)</span>
          </label>
          <v-text-field
            v-model="regSchoolName"
            variant="outlined"
            density="compact"
            placeholder="학교 이름을 입력해주세요."
            hide-details="auto"
          />
        </div>

        <div class="field-group">
          <label class="field-label">
            선생님 성함 <span class="field-hint-inline">(선택 · 연락처/이메일 입력 시 필수)</span>
          </label>
          <v-text-field
            v-model="regTeacherName"
            variant="outlined"
            density="compact"
            placeholder="담당 선생님 성함"
            hide-details="auto"
          />
        </div>

        <div class="field-group">
          <label class="field-label">연락처 (선택)</label>
          <v-text-field
            v-model="regTel"
            variant="outlined"
            density="compact"
            placeholder="전화번호"
            hide-details="auto"
          />
        </div>

        <div class="field-group">
          <label class="field-label">이메일 주소 (선택)</label>
          <v-text-field
            v-model="regMail"
            variant="outlined"
            density="compact"
            placeholder="이메일 주소"
            hide-details="auto"
          />
        </div>

        <div class="field-group">
          <label class="field-label">
            분류
          </label>
          <v-select
            v-model="regClassification"
            :items="classificationOptions"
            variant="outlined"
            density="compact"
            placeholder="분류를 선택해주세요 (미선택 시 유료)"
            hide-details="auto"
          />
        </div>
      </div>

      <template #footer>
        <v-btn variant="flat" color="primary" class="btn-primary" @click="registerSchool()">
          등록
        </v-btn>
      </template>
    </FormCard>

    <FormCard header="발급">
      <div class="field-group">
        <label class="field-label">
          학교 선택 <span class="field-required">(필수)</span>
        </label>
        <v-autocomplete
          @keyup.enter="schoolsearch()"
          auto-select-first
          append-inner-icon="mdi-magnify"
          item-props
          density="compact"
          menu-icon=""
          variant="outlined"
          v-model="searchschool"
          :items="searchlist"
          color="primary"
          placeholder="학교를 검색해주세요."
          spellcheck="false"
          theme="light"
          hide-details="auto"
        />
        <p class="field-helper">검색 후 Enter 키로 학교를 확정하세요.</p>
      </div>

      <div class="field-group">
        <label class="field-label">
          파일 업로드 <span class="field-required">(필수)</span>
        </label>
        <v-file-input
          density="compact"
          v-model="accountfile"
          variant="outlined"
          label="파일 업로드"
          accept=".xlsx,.csv"
          hide-details="auto"
        />
        <p class="field-helper">xlsx 또는 csv 파일만 허용됩니다.</p>
        <p v-if="fileerrortext" class="field-error">
          <v-icon icon="mdi-close-circle-outline" size="14" />
          {{ fileerrortext }}
        </p>
        <p v-if="successtext" class="field-success">
          <v-icon icon="mdi-check-circle-outline" size="14" />
          {{ successtext }}
        </p>
      </div>

      <div class="field-group master-account-group">
        <div class="master-account-header">
          <span class="field-label master-account-title">총괄 계정 발급</span>
          <input
            type="checkbox"
            v-model="masterAccountEnabled"
            class="master-account-checkbox"
          />
        </div>
        <v-text-field
          v-model="masterAccountName"
          :disabled="!masterAccountEnabled"
          density="compact"
          variant="outlined"
          placeholder="이름 (미입력 시 '총괄'로 발급)"
          hide-details="auto"
        />
      </div>

      <div class="field-group master-account-group">
        <div class="master-account-header">
          <span class="field-label master-account-title">비밀번호 일괄 설정</span>
          <input
            type="checkbox"
            v-model="bulkPasswordEnabled"
            class="master-account-checkbox"
          />
        </div>
        <v-text-field
          v-model="bulkPassword"
          :disabled="!bulkPasswordEnabled"
          type="password"
          density="compact"
          variant="outlined"
          placeholder="비밀번호 입력 (발급 직후 학교 전체 계정에 적용)"
          hide-details="auto"
        />
      </div>

      <template #footer>
        <v-btn
          v-if="masterAccountEnabled"
          variant="flat"
          color="primary"
          class="btn-primary"
          @click="issueMasterOnly()"
        >총괄 계정 발급</v-btn>
        <v-btn
          variant="outlined"
          color="default"
          class="btn-secondary"
          @click="filecheck()"
        >정보 확인</v-btn>
        <v-btn
          v-if="issueflag"
          variant="flat"
          color="primary"
          class="btn-primary"
          @click="postaccountfile()"
        >계정 생성</v-btn>
      </template>
    </FormCard>
    </div>

    <!-- 전달 카드 너비를 위 "학교 등록" 칸과 동일하게 맞춘다 (side-by-side 절반 폭) -->
    <div class="forward-wrap">
      <AccountForward />
    </div>

    <div v-if="isSent" class="result-banner">
      <v-icon icon="mdi-check-circle" size="20" />
      <div>
        <p class="result-banner__title">계정이 정상적으로 발급되었습니다.</p>
        <p class="result-banner__sub">
          비밀번호 설정, 방학중지 처리를 원하시면 <b>'계정 세팅/전달'</b> 페이지로 이동해주세요.
          계정 전달은 아래에서 바로 진행할 수 있습니다.
        </p>
      </div>
    </div>

    <FormCard v-if="isChecked" header="학교 정보">
      <div class="info-table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>학교 이름</th>
              <th>코드</th>
              <th>계약 시작일</th>
              <th>계약 만료일</th>
              <th>학생 계정수</th>
              <th>교사 계정수</th>
              <th>LMS 계정수</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ accountschoolinfo.schoolname }}</td>
              <td class="mono">{{ accountschoolinfo.schoolcode }}</td>
              <td>{{ accountschoolinfo.startDay }}</td>
              <td>{{ accountschoolinfo.endDay }}</td>
              <td class="num">{{ accountinfo.studentList.length }}</td>
              <td class="num">{{ accountinfo.teacherList.length }}</td>
              <td class="num">{{ accountinfo.lmsList.length }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </FormCard>

    <FormCard v-if="isChecked" header="학급 정보">
      <div class="info-table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>학년</th>
              <th>반</th>
              <th>출판사</th>
              <th>학생수</th>
              <th>영어 교사</th>
              <th>담임 교사</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(j, i) in accountclassinfo" :key="i">
              <td>{{ j.grade || "-" }}</td>
              <td>{{ j.classNum || "-" }}</td>
              <td>{{ j.publisher || "-" }}</td>
              <td class="num">{{ j.studentCnt || "-" }}</td>
              <td>{{ j.engTeacher || "-" }}</td>
              <td>{{ j.teacher || "-" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </FormCard>

    <FormCard v-if="isChecked" header="교사 LMS 계정">
      <div class="info-table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>이름</th>
              <th>ID</th>
              <th>담당 학급</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(j, i) in accountinfo.lmsList" :key="i">
              <td>{{ j.name }}</td>
              <td class="mono">{{ j.id }}</td>
              <td>{{ j.classList.join(", ") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </FormCard>

    <FormCard v-if="isChecked" header="교사 알공 계정">
      <div class="info-table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>학년</th>
              <th>반</th>
              <th>이름</th>
              <th>아이디</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(j, i) in accountinfo.teacherList" :key="i">
              <td>{{ j.grade }}</td>
              <td>{{ j.classNum }}</td>
              <td>{{ j.name }}</td>
              <td class="mono">{{ j.id }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </FormCard>

    <FormCard v-if="isChecked" header="학생 알공 계정">
      <div class="info-table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>학년</th>
              <th>반</th>
              <th>이름</th>
              <th>아이디</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(j, i) in accountinfo.studentList" :key="i">
              <td>{{ j.grade }}</td>
              <td>{{ j.classNum }}</td>
              <td>{{ j.name }}</td>
              <td class="mono">{{ j.id }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </FormCard>
  </div>
</template>

<script>
import {
  getaccountissuerecord,
  setaccountissuerecord,
  createMasterLms,
  postpasswordcustom,
} from "@/api/user-api-list";
import { PageHeader, FormCard } from "@/components/ui";
import AccountForward from "./AccountForwardComponent.vue";
import { OFFICE_OPTIONS } from "@/constants/schoolType";

export default {
  components: { PageHeader, FormCard, AccountForward },
  async created() {
    // [보류] 발급완료 학교 제외(QA 재요청 9/9)는 적용 보류 — 유료 805교 중 794교가
    // '발급완료'라 제외 시 검색 후보가 11교만 남고, 엑셀 추가 발급(기존 학교에 학급
    // 추가) 워크플로의 학교 선택이 막힘. 운영 재확인 후 적용하려면 아래를
    // dispatch("GET_SEARCH_LIST", "issued") 로 변경 (백엔드 옵션은 배포돼 있음).
    // 상세: docs/rina-merge/qa-feedback-1020.md
    const res = await this.$store.dispatch("GET_SEARCH_LIST");
    this.searchdata = res;
    this.searchlist = Object.getOwnPropertyNames(res);
  },
  data() {
    return {
      searchdata: "",
      searchlist: [],
      searchschool: null,
      fileerrortext: "",
      successtext: "",
      schoolcode: "",
      isChecked: false,
      isSent: false,
      accountfile: [],
      issueflag: false,
      // [총괄 계정 발급] — 신청 파일 없이 전 학급 조회용 LMS 계정만 단독 발급
      // (POST /admin/users/create/master-lms). rina 9/11에서 비밀번호 UI로 교체됐지만
      // renewal에서는 API에 연결된 기능이라 유지하고 두 블록을 나란히 둔다.
      masterAccountEnabled: false,
      masterAccountName: "",
      // [비밀번호 일괄 설정] — 엑셀 발급 성공 직후 학교 전체 계정 비밀번호를 지정값으로
      // 변경 (POST /admin/users/account/password/custom — contractYear.settingPw도 함께 갱신).
      bulkPasswordEnabled: false,
      bulkPassword: "",
      accountclassinfo: [],
      accountschoolinfo: {},
      accountinfo: {},

      // 학교 등록 — 학교 관리(allschool.vue)에서 이동
      regOffice: "",
      regLocation: "",
      regSchoolName: "",
      regClassification: "",
      regTeacherName: "",
      regTel: "",
      regMail: "",
      offices: OFFICE_OPTIONS,
      classificationOptions: ["무료", "연수", "서포터즈", "AI미래교육연구회", "박람회"],
    };
  },
  methods: {
    async schoolsearch() {
      if (this.searchdata[this.searchschool]) {
        let regex = /^[a-zA-Z0-9]*$/;

        if (regex.test(this.searchschool)) {
          this.schoolcode = this.searchschool;
          this.searchschool = this.searchdata[this.searchschool];
        } else {
          this.schoolcode = this.searchdata[this.searchschool];
        }

        const res = await getaccountissuerecord({
          schoolCode: this.schoolcode,
        });

        if (res.data.data.length) {
          alert("해당 학교에 발급 후 전달되지 않은 계정이 존재합니다.");
          return;
        }

        alert(
          `학교 이름 : ${this.searchschool}\n학교 코드 : ${this.schoolcode}\n설정되었습니다.`
        );
      } else {
        this.searchschool = "";
        this.schoolcode = "";
        alert("학교 정보가 존재하지 않습니다.");
      }
    },
    paging(data) {
      const size = 5;
      const arr = [];
      for (let i = 0; i < data.length; i += size) {
        arr.push(data.slice(i, i + size));
      }
      return arr;
    },
    // 신청 파일 없이 총괄(전 학급 조회용 LMS) 계정만 단독 발급
    async issueMasterOnly() {
      if (!this.schoolcode) {
        this.fileerrortext = "먼저 학교를 검색해주세요.";
        return;
      }
      const name = (this.masterAccountName || "").trim();
      if (!window.confirm(`총괄 계정을 발급하시겠습니까? (이름: ${name || "총괄"})`)) return;

      const res = await createMasterLms(this.schoolcode, name);
      const data = res?.data?.data;
      if (data === -1) {
        alert("학교를 찾을 수 없습니다.");
      } else if (data === -2) {
        alert("발급된 학급이 없어 총괄 계정을 만들 수 없습니다. 학생/교사 계정을 먼저 발급해주세요.");
      } else if (data && data.id) {
        alert(
          data.updated
            ? `이미 총괄 계정(${data.id})이 있어 담당 학급만 최신으로 갱신했습니다. (${data.classCount}개 반)`
            : `총괄 계정이 발급되었습니다.\nID: ${data.id} / 비밀번호: 000000 (${data.classCount}개 반)`
        );
        this.masterAccountEnabled = false;
        this.masterAccountName = "";
      } else {
        alert("총괄 계정 발급 중 오류가 발생했습니다.");
      }
    },
    async filecheck() {
      if (!this.schoolcode) {
        this.fileerrortext = "먼저 학교를 검색해주세요.";
        return;
      }
      if (!this.accountfile[0]) {
        this.fileerrortext = "먼저 파일을 업로드해주세요.";
        return;
      }
      const req = this.accountfile[0];
      let dot_index = req.name.lastIndexOf(".");
      let temp = req.name.substring(dot_index + 1, req.name.length);
      temp = temp.toLowerCase();
      if (temp !== "xlsx" && temp !== "csv") {
        this.fileerrortext = "엑셀 파일만 업로드해주세요";
        return;
      }
      const data = new FormData();
      data.append("file", req);
      const res = await this.$store.dispatch("ACCOUNT_FILE_CHECK", data);
      if (res == true) {
        this.issueflag = true;
        this.fileerrortext = "";
        this.successtext = "유효성 검사를 통과하였습니다.";
        return;
      } else {
        this.issueflag = false;
        this.successtext = "";
        this.fileerrortext = res;
        this.accountfile = [];
        return;
      }
    },
    async postaccountfile() {
      const bulkPassword = (this.bulkPassword || "").trim();
      if (this.bulkPasswordEnabled && !bulkPassword) {
        this.fileerrortext = "비밀번호 일괄 설정이 켜져 있습니다. 비밀번호를 입력하거나 체크를 해제해주세요.";
        return;
      }
      this.$store.state.loading = true;
      const formdata = new FormData();
      formdata.append("file", this.accountfile[0]);
      formdata.append("schoolCode", this.schoolcode);
      const res = await this.$store.dispatch("POST_ACCOUNT_FILE", formdata);
      if (res.schoolStartDate) {
        // 비밀번호 일괄 설정 — 발급이 끝난 뒤 학교 전체 계정(기존 포함)에 적용
        let bulkPasswordNote = "";
        if (this.bulkPasswordEnabled) {
          const pwRes = await postpasswordcustom({
            schoolCode: this.schoolcode,
            password: bulkPassword,
          });
          const ok = pwRes?.data?.result === true;
          bulkPasswordNote = ok
            ? "\n비밀번호가 일괄 설정되었습니다."
            : "\n비밀번호 일괄 설정에 실패했습니다. 학교 상세에서 다시 변경해주세요.";
          if (ok) {
            this.bulkPasswordEnabled = false;
            this.bulkPassword = "";
          }
        }
        setTimeout(async () => {
          this.accountclassinfo = await this.$store.dispatch(
            "GET_SCHOOL_CLASS_LIST",
            this.schoolcode
          );
          const startDay = res.schoolStartDate.split("T")[0];
          const endDay = res.schoolEndDate.split("T")[0];
          this.accountschoolinfo = {
            schoolname: this.searchschool,
            schoolcode: this.schoolcode,
            startDay,
            endDay,
          };
          this.accountinfo = await this.$store.dispatch(
            "GET_TYPE_USERS",
            this.schoolcode
          );
          await setaccountissuerecord({
            schoolCode: this.schoolcode,
            accounts: this.accountinfo.lmsList,
          });
          this.$store.state.loading = false;
          this.isSent = true;
          this.isChecked = true;
          alert("계정이 생성되었습니다." + bulkPasswordNote);
        }, 2000);
        return;
      } else {
        alert("계정 생성 중 오류가 발생하였습니다.");
        return;
      }
    },
    // 분류 → schoolLevel/type 매핑 (학교 조회 SchoolBrowseView.vue의 분류 체계와 동일)
    classificationToLevelType(classification) {
      const map = {
        유료: { schoolLevel: "user", type: "" },
        무료: { schoolLevel: "guest", type: "무료 체험" },
        연수: { schoolLevel: "guest", type: "교사 연수" },
        서포터즈: { schoolLevel: "guest", type: "서포터즈" },
        AI미래교육연구회: { schoolLevel: "guest", type: "AI미래교육연구회" },
        박람회: { schoolLevel: "guest", type: "박람회" },
      };
      return map[classification];
    },
    async registerSchool() {
      if (!this.regOffice || !this.regSchoolName) {
        alert("교육청과 학교이름을 입력해주세요.");
        return;
      }

      // 연락처(성함/전화/이메일)는 선택 — 하나라도 적었으면 성함은 있어야 한다.
      const teacherName = this.regTeacherName.trim();
      const tel = this.regTel.trim();
      const mail = this.regMail.trim();
      const hasContact = Boolean(teacherName || tel || mail);
      if (hasContact && !teacherName) {
        alert("연락처나 이메일을 입력할 때는 선생님 성함도 입력해주세요.");
        return;
      }

      // 분류 미선택 시 기본값 "유료" 적용
      const classification = this.regClassification || "유료";
      const levelType = this.classificationToLevelType(classification);
      if (
        !window.confirm(
          `교육청: ${this.regOffice}\n지역: ${this.regLocation || "-"}\n학교 이름: ${this.regSchoolName}\n분류: ${classification}\n\n해당 정보로 학교를 등록하시겠습니까?`
        )
      ) {
        return;
      }

      const res = await this.$store.dispatch("REGISTER_SCHOOL", {
        office: this.regOffice,
        location: this.regLocation,
        schoolName: this.regSchoolName,
        ...levelType,
      });

      if (!res || !res.schoolCode) {
        alert("학교 등록 중 오류가 발생했습니다.");
        return;
      }

      // 연락처를 입력하지 않았으면 학교만 등록하고 연락처 추가는 건너뛴다.
      if (hasContact) {
        await this.$store.dispatch("POST_SCHOOL_CREATE_CONTACT", {
          schoolCode: res.schoolCode,
          contact: {
            name: teacherName,
            tel,
            mail,
            telCheck: false,
            mailCheck: false,
            memo: "",
          },
        });
      }

      alert("학교 등록이 완료되었습니다.");
      this.regOffice = "";
      this.regLocation = "";
      this.regSchoolName = "";
      this.regClassification = "";
      this.regTeacherName = "";
      this.regTel = "";
      this.regMail = "";
    },
  },
};
</script>

<style scoped>
/* 화면에 스크롤 없이 한 번에 들어오도록 전체적으로 여백/카드 크기를 축소 */
.page-wrap {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

:deep(.form-card) {
  padding: var(--space-4) var(--space-5);
}
:deep(.form-card__header) {
  font-size: 17px;
  font-weight: 700;
  margin-bottom: var(--space-3);
}
:deep(.form-card__footer) {
  margin-top: var(--space-4);
  padding-top: var(--space-4);
}

/* 입력창/드롭다운/검색창 글씨 크기를 라벨(14px)과 맞추고, 칸 자체 높이도 축소 */
:deep(.v-field) {
  font-size: 14px;
}
:deep(.v-field__input) {
  min-height: 38px !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  font-size: 14px !important;
}
:deep(.v-field__input input),
:deep(.v-select__selection-text),
:deep(.v-autocomplete__selection) {
  font-size: 14px !important;
}
:deep(.v-field__field) {
  min-height: 38px !important;
}
:deep(.v-label) {
  font-size: 14px;
}
/* 버튼 글자 자간(대문자 강조용 기본값)이 다른 글자와 다르게 벌어져 보이던 것 통일 */
:deep(.v-btn) {
  letter-spacing: normal !important;
}

/* 학교 등록 / 발급 카드를 한 줄에 나란히 배치, 높이도 서로 맞춘다(stretch).
   전달은 연락처 목록이 아래로 늘어나는 구조라 별도 줄에 둔다. */
.side-by-side {
  display: flex;
  align-items: stretch;
  gap: var(--space-4);
}
.side-by-side > * {
  flex: 1 1 0;
  min-width: 0;
}
@media (max-width: 900px) {
  .side-by-side {
    flex-direction: column;
  }
}


.register-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-3);
}
.register-grid .field-group {
  margin-bottom: 0;
}
@media (max-width: 500px) {
  .register-grid {
    grid-template-columns: 1fr;
  }
}

.field-hint-inline {
  font-weight: 400;
  color: var(--text-tertiary);
  font-size: var(--font-small-size);
}

.field-group {
  margin-bottom: var(--space-3);
}
.field-group:last-child {
  margin-bottom: 0;
}
/* 입력창이 카드/그리드 칸 너비에 맞춰 불필요하게 늘어나지 않도록 상한 지정 */
.field-group :deep(.v-input) {
  max-width: 320px;
}

.field-label {
  display: block;
  margin-bottom: var(--space-2);
  font-size: var(--font-body-strong-size);
  line-height: var(--font-body-strong-line);
  font-weight: var(--font-body-strong-weight);
  color: var(--text-primary);
}

.field-required {
  margin-left: var(--space-1);
  color: var(--color-error-text, #B42318);
  font-weight: 400;
  font-size: var(--font-small-size);
}

.field-helper {
  margin: var(--space-1) 0 0;
  font-size: var(--font-small-size);
  line-height: var(--font-small-line);
  color: var(--text-tertiary);
}

.field-error {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  margin: var(--space-1) 0 0;
  font-size: var(--font-small-size);
  color: var(--color-error-text, #B42318);
}

.field-success {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  margin: var(--space-1) 0 0;
  font-size: var(--font-small-size);
  color: var(--color-success-text, #1F7A3A);
}

.master-account-group {
  padding-top: var(--space-3);
  border-top: 1px solid var(--border-default);
}
.master-account-header {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  margin-bottom: var(--space-2);
}
.master-account-title {
  margin-bottom: 0;
}
.master-account-checkbox {
  width: 16px;
  height: 16px;
  accent-color: var(--color-primary-600);
  cursor: pointer;
}

.btn-primary {
  font-weight: 600;
}
.btn-secondary {
  font-weight: 500;
}

.result-banner {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-5);
  background: var(--color-primary-50);
  border: 1px solid var(--color-primary-300, #7FA8F4);
  border-radius: var(--radius-md);
  color: var(--color-primary-900);
}

.result-banner__title {
  margin: 0 0 var(--space-1);
  font-size: var(--font-body-strong-size);
  font-weight: var(--font-body-strong-weight);
  color: var(--text-primary);
}

.result-banner__sub {
  margin: 0;
  font-size: var(--font-small-size);
  color: var(--text-secondary);
}

.info-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-sm);
}

.info-table {
  width: 100%;
  min-width: 400px;
  border-collapse: collapse;
  font-size: var(--font-body-size);
  line-height: var(--font-body-line);
  color: var(--text-primary);
  background: var(--bg-surface);
}

.info-table thead th {
  padding: var(--space-3) var(--space-4);
  background: var(--bg-subtle);
  color: var(--text-secondary);
  font-size: var(--font-body-strong-size);
  font-weight: var(--font-body-strong-weight);
  text-align: center;
  border-bottom: 1px solid var(--border-default);
  white-space: nowrap;
}

.info-table tbody td {
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--border-default);
  text-align: center;
}

.info-table tbody tr:last-child td {
  border-bottom: none;
}

.info-table td.num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.info-table td.mono {
  font-family: var(--font-mono-family, "JetBrains Mono", "D2Coding", monospace);
  font-size: var(--font-mono-size, 13px);
}
</style>
